import { event, payload } from '@conversa/reflex';

export const ActivityPageUpdated = event(
  '[ component | Activity ] Activity Page Updated',
  payload<{ page: number }>(),
);
